import * as React from "react";
import * as ReactDom from "react-dom";
import { SlideView } from "ts/confit/pub/slide/SlideView";

/** window Thymeleafパラメータ拡張 */
interface WindowExtParam extends Window {
  /** 画像URLリスト */
  imageUrlList?: Array<string>;
}

window.addEventListener("load", () => {
  const windowExt: WindowExtParam = window;
  ReactDom.render(
    (
      <SlideView imageUrlList={windowExt.imageUrlList ? windowExt.imageUrlList : []} />
    ),
    document.getElementById("root")
  );
});
